import styled, { css } from "styled-components";
import { lighten } from "polished";

import { IPlaygroundStyleProps } from "./interfaces";

export const HideOnComplete = css`
    &.HideOnComplete {
        transition: 1s;
        opacity: 0;
        pointer-events: none;
    }
`;

export const Drop = styled.div`
    position: absolute;

    border-radius: 14px;
    box-shadow: none;
    border: 3px solid black;
    box-sizing: border-box;
    background-color: white;
    transition: background-color 0.2s;

    &.Christmas {
        border: 5px solid ${p => p.theme.c.christmasBlue};
        border-radius: 0;
        box-shadow: 0 0 0 1px #666;
    }
    &.Active {
        background-color: #ddd;
    }
    &.Playing {
        background-color: ${p => lighten(0.3, p.theme.c.play)};
    }
    ${HideOnComplete}
`;

export const Playground = styled.div<IPlaygroundStyleProps>`
    height: 100%;
    ${p =>
        p.isLow &&
        css`
            transform: scale(0.55);
            margin-top: -83px;
        `}
`;

export const Asset1Wrapper = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: none;

    img {
        width: 1280px;
    }
`;

export const ScoreWrapper = styled.div`
    position: absolute;
    transform-origin: top left;
    overflow: hidden;
`;

export const ScorePositioner = styled.div`
    transform-origin: top left;
    > div {
        overflow: hidden;
    }
`;
